import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import Header from './Header';
import TabNavigation from './TabNavigation';
import Footer from './Footer';
import './MainLayout.css';

/**
 * MainLayout Component
 * 
 * Main application layout wrapper with header, navigation, content area, and footer
 */
export default function MainLayout({ showTabs = true, tabs = [] }) {
  return (
    <div className="main-layout">
      <Header />
      {showTabs && tabs.length > 0 && <TabNavigation tabs={tabs} />}
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

MainLayout.propTypes = {
  showTabs: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  )
};
